import localizationStrings from "./Localization";

export default localizationStrings;
